import layoutStyles from '../../assets/css/layout.module.css';
import { WithChildren } from '../../types/utility';

export const AppLayout = ({ children }: WithChildren) => {
	return (
		<div className={layoutStyles['bank-app-root']} style={{ width: '100%' }}>
			{children}
		</div>
	);
};
